export default __webpack_public_path__ + "static/media/calender.a3d1278d.svg";